import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getShopById } from "../api";
import { useAuth } from "../auth/AuthProvider";
import ControlsDataTable from "../components/ControlsDataTable";

function ShopDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { withAuth } = useAuth();
    const [shop, setShop] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;

        async function load() {
            setLoading(true);
            setError("");

            const shopId = Number.parseInt(String(id), 10);
            if (!Number.isInteger(shopId) || shopId <= 0) {
                if (!cancelled) {
                    setShop(null);
                    setLoading(false);
                    setError("ID atelier invalide.");
                }
                return;
            }

            try {
                const data = await withAuth((token) => getShopById(token, shopId));
                if (!cancelled) {
                    setShop(data?.shop || null);
                }
            } catch {
                if (!cancelled) {
                    setShop(null);
                    setError("Impossible de charger le détail de l'atelier.");
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        load();

        return () => {
            cancelled = true;
        };
    }, [id, withAuth]);

    return (
        <section>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1 className="h4 mb-1">Détail atelier</h1>
                    <p className="text-secondary mb-0">Informations complètes de l'atelier.</p>
                </div>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => navigate(-1)}
                >
                    Retour
                </button>
            </div>

            <div className="card shadow-sm">
                <div className="card-body">
                    {loading ? (
                        <p className="text-secondary mb-0">Chargement...</p>
                    ) : error ? (
                        <div className="alert alert-warning py-2 mb-0">{error}</div>
                    ) : !shop ? (
                        <p className="text-secondary mb-0">Atelier introuvable.</p>
                    ) : (
                        <dl className="row mb-0">
                            <dt className="col-sm-3">ID</dt>
                            <dd className="col-sm-9">{shop.id}</dd>

                            <dt className="col-sm-3">Nom</dt>
                            <dd className="col-sm-9">{shop.name || "-"}</dd>

                            <dt className="col-sm-3">Email</dt>
                            <dd className="col-sm-9">{shop.email || "-"}</dd>

                            <dt className="col-sm-3">Téléphone</dt>
                            <dd className="col-sm-9">{shop.phone || "-"}</dd>

                            <dt className="col-sm-3">Adresse</dt>
                            <dd className="col-sm-9">{shop.address || "-"}</dd>

                            <dt className="col-sm-3">Responsable</dt>
                            <dd className="col-sm-9">{shop.principle || "-"}</dd>

                            <dt className="col-sm-3">Fax</dt>
                            <dd className="col-sm-9">{shop.fax_code || "-"}</dd>
                        </dl>
                    )}
                </div>
            </div>

            {!loading && !error && shop && (
                <div className="mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <h2 className="h5 mb-1">Contrôles de l'atelier</h2>
                            <p className="text-secondary mb-0">Liste paginée des contrôles liés à cet atelier.</p>
                        </div>
                    </div>

                    <ControlsDataTable shopId={shop.id} hideShopColumns filtersWhitelist={shop.test_type_ids} />
                </div>
            )}
        </section>
    );
}

export default ShopDetailPage;